import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { useCart } from "../../context/CartContext";
import { decodeIdToken } from "../../utils/auth";
import styles from "./BuyNowSucess.module.css";

export default function BuyNowSuccess() {
  const { clear } = useCart();
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [role, setRole] = useState<"provider" | "patient" | null>(null);
  const [name, setName] = useState<string | null>(null);

  const handleSignOut = () => {
    localStorage.removeItem("idToken");
    localStorage.removeItem("accessToken");
    window.location.href = "/login";
  };

  // Decode user + role
  useEffect(() => {
    const decoded = decodeIdToken();
    if (!decoded) return handleSignOut();

    const groups = decoded["cognito:groups"] ?? [];
    setRole(
      groups.some((g) => g.toLowerCase() === "provider") ? "provider" : "patient"
    );
    setName((decoded.given_name as string) || decoded.name || "User");
  }, []);

  // Read session id from query
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("session_id");
    if (id) setSessionId(id);
  }, []);

  const dashboardHref = role === "provider" ? "/dashboard" : "/patient-dashboard";

  const redirectDashboard = () => {
    window.location.href = dashboardHref;
  };

  // Clear the cart on a successful purchase
  useEffect(() => {
    clear();
  }, [clear]);

  return (
    <main id="main" className="ui-page">
      <div className="ui-container">
        <section
          className={`ui-card ui-card--lg ${styles.card}`}
          aria-labelledby="success-title"
        >
          <span className={styles.successCircle} aria-hidden="true">
            <IoCheckmarkCircle size={36} />
          </span>

          <h1 id="success-title">Purchase successful</h1>

          <div className={styles.copy}>
            <p>
              Thank you for your order{name ? `, ${name}` : ""}. A receipt has been sent to
              your email.
            </p>
            <p className={styles.sub}>
              You can view your order details anytime in your{" "}
              <a className="ui-link" href={dashboardHref}>
                dashboard
              </a>
              .
            </p>
          </div>

          <div className={styles.summary} role="group" aria-label="Order summary">
            <div className={styles.row}>
              <span className={styles.rowLabel}>Order ID</span>
              <span className={styles.orderId} aria-live="polite">
                {sessionId || "Loading..."}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.rowLabel}>Status</span>
              <span className="ui-badge ui-badge--success">Paid</span>
            </div>
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              onClick={redirectDashboard}
              className="ui-btn ui-btn--full"
            >
              Go to dashboard
            </button>
            <Link className="ui-btn ui-btn--ghost" to="/shopping">
              Back to the shop
            </Link>
          </div>

          {/* Live region for any dynamic status in the future */}
          <p className={styles.live} aria-live="polite" />
        </section>
      </div>
    </main>
  );
}
